// SafeToast.js
import React from 'react';
import { Toast } from 'primereact/toast';

class SafeToast extends React.Component {
    constructor(props) {
        super(props);
        this.toastRef = React.createRef();
    }

    show = (options) => {
        try {
            if (this.toastRef && this.toastRef.current) {
                this.toastRef.current.show(options);
            } else {
                console.error('Toast reference not available:', options);
            }
        } catch (error) {
            console.error('Error showing toast notification:', error);
            console.info('Toast message was:', options);
        }
    }

    render() {
        return <Toast ref={this.toastRef} position={this.props.position || "bottom-right"} />;
    }
}

export default SafeToast;